import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { logEvent } from 'firebase/analytics';

import NavData from '@/config/data/nav/nav_data.json';
import { getNewsList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import useContent from '@/localization/data_export';

import analytics from '../../../firebase';
import './css/news_common_aside.scss';
import { convertDate } from '@/components/broadcast-at';

function NewsCommonAside() {
  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const { mode } = useSelector((state) => state);

  const [newsItem] = useAxios(
    getNewsList,
    [],
    { lan_code: 'en', page_info: { row_count: 10, number: 0 }, is_list_allow: false },
    true
  );
  const [newsPopularItem] = useAxios(
    getNewsList,
    [],
    {
      lan_code: 'en',
      is_hit_count: true,
      start_reg_date: dayjs.tz().subtract(7, 'day').format('YYYY-MM-DD'),
      end_reg_date: dayjs.tz().subtract(0, 'day').format('YYYY-MM-DD'),
      page_info: { row_count: 5, number: 0 },
    },
    true
  );
  const { data: newsData } = newsItem;
  const { data: newsPopularData } = newsPopularItem;

  return (
    <div id="NewsCommonAside" className="newsCommonAside">
      <div className="latestNews">
        <h3 className="title">
          <span className="boldText">Latest</span> News
        </h3>
        <ul className="listWrap">
          {newsData?.item.map((v, i) => {
            return (
              i < 10 && (
                <li className="list" key={`newsAside_${i}`}>
                  <Link
                    to={`${NavData['NEWS_VIEW'].path}?id=${v.news_id}`}
                    className="list_link"
                    onClick={() =>
                      logEvent(analytics, 'select_item', {
                        item_list_name: `${v?.title[0]?.text}`,
                        item_list_id: `news_${v?.news_id}`,
                        items: [
                          {
                            item_id: `${v.news_id}`,
                            item_name: `${v.title[0].text}`,
                            item_brand: 'article',
                          },
                        ],
                      })
                    }
                    title={anchorTitle}
                  >
                    <p
                      className="list_text"
                      dangerouslySetInnerHTML={{
                        __html:
                          mode === 'en'
                            ? v.title[0].text
                            : v.title[1].text === '' || v.title[1].text.length === 0
                            ? v.title[0].text
                            : v.title[1].text,
                      }}
                    />
                    <p className="list_date time-fs-fixed">{convertDate(v.broadcast_date)}</p>
                  </Link>
                </li>
              )
            );
          })}
        </ul>
      </div>
      <div className="mostPopular">
        <h3 className="title">
          Most <span className="boldText">Popular</span>
        </h3>
        <ul className="listWrap">
          {newsPopularData?.item.map((v, i) => (
            <li className="list" key={`newsAsidePopluar_${i}`}>
              <Link
                to={`${NavData['NEWS_VIEW'].path}?id=${v.news_id}`}
                className="list_link"
                onClick={() =>
                  logEvent(analytics, 'select_item', {
                    item_list_name: `${v?.title[0]?.text}`,
                    item_list_id: `news_${v?.news_id}`,
                    items: [
                      {
                        item_id: `${v.news_id}`,
                        item_name: `${v.title[0].text}`,
                        item_brand: 'article',
                      },
                    ],
                  })
                }
                title={anchorTitle}
              >
                <div className="list_wrap">
                  <span className="list_num">{i + 1}</span>
                  <p
                    className="list_text"
                    dangerouslySetInnerHTML={{
                      __html:
                        mode === 'en'
                          ? v.title[0].text
                          : v.title[1].text === '' || v.title[1].text.length === 0
                          ? v.title[0].text
                          : v.title[1].text,
                    }}
                  />
                </div>
                <div>
                  <p className="list_date time-fs-fixed">{convertDate(v.broadcast_date)}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default NewsCommonAside;
